<template>
    <div class="content">
        <HomeSectionHero />
        <div class="function-app container-fluid">
            <HomeSectionVideo />
            <HomeSectionTutorial id="about" class="section-snap"/>
            <HomeSectionNotifications id="fuctionality" class="section-snap"/>
        </div>
        <HomeSectionNewsletter />
        <HomeSectionDownload />
    </div>
</template>

<script>
import HomeSectionHero from "@/components/HomeSectionHero";
import HomeSectionVideo from  "@/components/HomeSectionVideo";
import HomeSectionTutorial from "@/components/HomeSectionTutorial";
import HomeSectionNotifications from "@/components/HomeSectionNotifications";
import HomeSectionNewsletter from "@/components/HomeSectionNewsletter";
import HomeSectionDownload from "@/components/HomeSectionDownload";

export default {
    name: 'Home',
    components: {
        HomeSectionHero,
        HomeSectionVideo,
        HomeSectionTutorial,
        HomeSectionNotifications,
        HomeSectionNewsletter,
        HomeSectionDownload
    }
};
</script>

<style lang="scss" scoped>

.section-snap {
    padding-top: 110px;
    width: 100%;
    height: 100%;
    min-height: 300px;
}

// Medium devices (desktops 1350px)
@media screen and (max-width: 1350px) {
    .function-app {
        background: none;
    }
}
// Medium devices (desktops, 1024px)
@media screen and (max-width: 1024px) {
    .section-snap {
        min-height: auto;
    }
}
// Medium devices (tablets, 768px)
@media screen and (max-width: 768px) {
    .section-snap {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;

        .function--app-sign-up {
            min-width: 100%;
        }
    }
}


@media screen and (max-width: 991px){
    .section-snap {
        padding-top: 90px;
    }
}
// Medium devices (mobile, 480px)
@media screen and (max-width: 480px) {
    .function-app {
        background: none;
    }
     .section-snap {
        max-height: 100%;
        min-height: auto;
    }


}
// Medium devices (mobile, 411px)
@media screen and (max-width: 411px) {
    .ahorro-notification {
        padding-top: 0px;
    }
}

@media screen and (min-width: 560px) {
    .section-snap {
        max-height: 580px;
    }
}

@media screen and (min-width: 1024px) {
    .section-snap {
        max-height: 640px;
    }
}

@media screen and (min-width: 1200px) {
    .section-snap {
        max-height: 580px;
    }
}
</style>
